import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ShieldAlert } from 'lucide-react';
import { Navigate } from 'react-router-dom';
import { defaultLandingFor, hasPerm, hasRole, resolvePersona, useAuthStore, } from '@/store/auth';
export function RoleGate({ personas, permissions, roles, redirectTo, children }) {
    const me = useAuthStore((s) => s.me);
    if (!me)
        return _jsx(Navigate, { to: "/login", replace: true });
    const persona = resolvePersona(me);
    // Super admin bypasses everything.
    if (persona === 'super_admin')
        return _jsx(_Fragment, { children: children });
    const personaOk = !personas || personas.includes(persona);
    const permOk = !permissions || permissions.some((p) => hasPerm(me, p));
    const roleOk = !roles || roles.some((r) => hasRole(me, r));
    if (personaOk && permOk && roleOk)
        return _jsx(_Fragment, { children: children });
    // Soft redirect to the user's natural landing instead of a hard 403.
    return _jsx(Navigate, { to: redirectTo ?? defaultLandingFor(persona), replace: true });
}
/** Inline forbidden screen — used by routes that don't want to redirect. */
export function ForbiddenView({ message }) {
    return (_jsxs("div", { className: "flex h-full flex-col items-center justify-center gap-3 p-12 text-center", children: [_jsx(ShieldAlert, { className: "h-10 w-10 text-rose-500" }), _jsx("div", { className: "text-lg font-semibold", children: "Access denied" }), _jsx("p", { className: "max-w-md text-sm text-slate-500", children: message ?? "Your role doesn't include access to this page. If you think this is a mistake, contact your tenant admin." })] }));
}
